import{Script as t}from"@magalu/rave/components";import e from"react";const r=()=>e.createElement(t,{htmlContent:"0",strategy:"beforeInteractive"});export{r as default};
